// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"ProductTechnicalInformationTable_paginationPageDropdownWrap__Df9KP","titleCase":"ProductTechnicalInformationTable_titleCase__rHB15"};